import { kDayList } from "@coreapp/constants";
import { appstr } from "@coreapp/utils/appstr";
import { isSharepointExportEnabled } from "@/Utils/Misc";
import {
  ChartSettingsSectionRoutes,
  getChartSettingsTestPrefix
} from "@/providers/NavigationProvider";

export const REFRESH_TEST_PREFIX = getChartSettingsTestPrefix(ChartSettingsSectionRoutes.Refresh);

export const formatOptions = [
  { label: "XLSX", value: "XLS" },
  { label: "PDF", value: "PDF" },
  { label: "Powerpoint", value: "PPT" }
];

export const getExportOptions = () => {
  const options = [{ label: "Email", value: "Email" }];
  if (isSharepointExportEnabled()) {
    options.push({ label: appstr("SharePoint"), value: "SharePoint" });
  }
  return options;
};

export const monthlyOptions = ["fotm", "motm", "eotm"];

export const validateDayValue = value => (kDayList.includes(value) ? value : "Wednesday");

export const validateDayOfMonthValue = value => (monthlyOptions.includes(value) ? value : "fotm");

export const updateFrequency = (value, key) => {
  const dayKey = key === "schedule" ? "day" : "exportDay";

  switch (value) {
    case "Daily":
      return key === "schedule" ? { [key]: value, syncHour: 0 } : {};
    case "Weekly":
      return {
        [key]: value,
        [dayKey]: "Wednesday",
        ...(key === "schedule" ? { syncHour: 0 } : {})
      };
    case "Monthly":
      return { [key]: value, [dayKey]: "fotm" };
    default:
      return key === "schedule" ? { [key]: "Off", exportFreq: "Off" } : { [key]: "Off" };
  }
};

export const buildRefreshOptions = (change, list, key) => {
  let options = [];
  for (var i = 0; i < list.length; i++) {
    let newOption = {};
    newOption.label = appstr(list[i]);
    newOption.value = list[i];
    newOption.clickHandler = target => change(target, key);
    options.push(newOption);
  }
  return options;
};

export const getRefreshOptions = (change, list) => {
  const options = [];
  for (let sourceObj of list) {
    let newOption = {};
    newOption.label = sourceObj.label;
    newOption.value = sourceObj.value;
    newOption.clickHandler = change;
    options.push(newOption);
  }
  return options;
};

export const convertEmailList = emailObj => {
  if (emailObj instanceof Array) return { notifications: [...emailObj], exports: [] };
  else return emailObj;
};
